<template>
  <div class="container">
    <div>
      <el-button type="primary" style="float:right;" @click="getRealData">刷新</el-button>
    </div>
    <div>
      <el-form label-position="left" inline class="demo-table-expand">
        <div class="sameLine">
          <el-form-item label="电台信道" style="width: 50%;">
            <span>时间:{{radioInfo.radioChannel.time}}</span><br/>
            <span>信道号:{{radioInfo.radioChannel.value}}</span><br/>
            <el-button type="primary" size="small" @click="getRadioHis()">历史记录</el-button>
            <el-dialog :visible="historyDialog" :close-on-click-modal='false' v-if="historyDialog"
                       @close="historyDialog=false">
              <el-date-picker
                v-model="hisTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-button type="primary" @click="searchHis()" style="margin-left: 20px">搜索</el-button>
              <el-table :data="historyTable">
                <el-table-column v-if="this.getRadioHistory.params.field!='mistakeSound'" label="时间" prop="time"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column v-if="this.getRadioHistory.params.field!='mistakeSound'" label="值" prop="value"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column v-if="this.getRadioHistory.params.field=='mistakeSound'" label="开始时间" prop="startTime"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column v-if="this.getRadioHistory.params.field=='mistakeSound'" label="结束时间" prop="endTime"
                                 show-overflow-tooltip></el-table-column>
              </el-table>
            </el-dialog>
          </el-form-item>
          <el-form-item label="信号强度">
            <span>时间:{{radioInfo.signalStrength.time}}</span><br/>
            <span>信号强度:{{radioInfo.signalStrength.value}}</span><br/>
            <el-button type="primary" size="small" @click="getSignalStrengthHis()">历史记录</el-button>
          </el-form-item>
        </div>
        <div class="sameLine">
          <el-form-item label="解调数据出错字节" style="width: 47%">
            <span>时间:{{radioInfo.mediationErrorNum.time}}</span><br/>
            <span>解调数据出错字节:{{radioInfo.mediationErrorNum.value}}</span><br/>
            <el-button type="primary" size="small" @click="getMediationErrorNumHis()">历史记录</el-button>
          </el-form-item>
          <el-form-item label="接收频偏">
            <span>时间:{{radioInfo.frequencyOffset.time}}</span><br/>
            <span>接收频偏:{{radioInfo.frequencyOffset.value}}</span><br/>
            <el-button type="primary" size="small" @click="getFrequencyOffsetHis()">历史记录</el-button>
          </el-form-item>
        </div>
        <div class="sameLine">
          <el-form-item label="误鸣状态" style="width: 47%;">
            <span>时间:{{radioInfo.mistakeSound.time}}</span><br/>
            <span>误鸣状态:{{radioInfo.mistakeSound.value}}</span><br/>
            <el-button type="primary" size="small" @click="getMistakeSoundHis()">历史记录</el-button>
          </el-form-item>
          <el-form-item label="有线情况">
            <span>{{radioInfo.wired}}</span><br/>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hardwareInfo',
    data () {
      return {
        historyDialog: false,
        historyTable: [],
        hisTime: [],
        getRadioInfo: {
          'version': 1,
          'method': 'radio.GetNewestRadioInfo',
          'params': {
            'devID': ''
          },
          'token': '',
          'id': 0
        },
        radioInfo: {},
        getRadioHistory: {
          'version': 1,
          'method': 'radio.GetRadioHistory',
          'params': {
            'devID': '',
            'field': '',
            'startTime': '',
            'endTime': ''
          },
          'token': '#',
          'id': 0
        }
      }
    },
    methods: {
      getRealData () {//获取实时数据
        this.getRadioInfo.params.devID = window.sessionStorage.getItem('devIDForHardInfo')
        this.getRadioHistory.params.devID = window.sessionStorage.getItem('devIDForHardInfo')
        this.$axios.post(this.$mainUrl, this.getRadioInfo).then(res => {
          if(res.data.hasOwnProperty('result')){
            this.radioInfo = res.data.result
          }else{
            this.$message.error(res.data.error.message)
          }
        })
      },
      getRadioHis () {
        this.historyTable = []
        this.hisTime = []
        this.historyDialog = true
        this.getRadioHistory.params.startTime = ''
        this.getRadioHistory.params.endTime = ''
        this.getRadioHistory.params.field = 'radioChannel'
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      },
      getSignalStrengthHis () {
        this.historyTable = []
        this.hisTime = []
        this.historyDialog = true
        this.getRadioHistory.params.startTime = ''
        this.getRadioHistory.params.endTime = ''
        this.getRadioHistory.params.field = 'signalStrength'
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      },
      getMediationErrorNumHis () {
        this.historyTable = []
        this.hisTime = []
        this.historyDialog = true
        this.getRadioHistory.params.startTime = ''
        this.getRadioHistory.params.endTime = ''
        this.getRadioHistory.params.field = 'mediationErrorNum'
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      },
      getFrequencyOffsetHis () {
        this.historyTable = []
        this.hisTime = []
        this.historyDialog = true
        this.getRadioHistory.params.startTime = ''
        this.getRadioHistory.params.endTime = ''
        this.getRadioHistory.params.field = 'frequencyOffset'
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      },
      getMistakeSoundHis () {
        this.historyTable = []
        this.hisTime = []
        this.historyDialog = true
        this.getRadioHistory.params.field = 'mistakeSound'
        this.getRadioHistory.params.startTime = ''
        this.getRadioHistory.params.endTime = ''
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      },
      searchHis () {
        this.historyTable = []
        this.getRadioHistory.params.startTime = this.hisTime[0]
        this.getRadioHistory.params.endTime = this.hisTime[1]
        for (let key in this.getRadioHistory.params) {
          if (this.getRadioHistory.params[key] === '') {
            this.getRadioHistory.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getRadioHistory).then(res => {
          this.historyTable = res.data.result.history
        })
      }
    },
    mounted () {
      this.getRealData()
      this.interval = setInterval(()=>{
        this.getRealData()
      }, 6000);

    },
    destroyed () {
      clearInterval(this.interval)
    }
  }
</script>

<style scoped>
  .sameLine {
    height: 150px;
    display: flex;
    flex-wrap: nowrap;
  }
</style>
